import appConfig from '@/app.config.js';
import { DAYS, NUMBER_OF_WEEKDAYS } from './DAYS';

export const calcDailyCapsFromWeeklyCap = daycaps => {
  const dailyCapAdjustmentFactor = parseFloat(appConfig.weeklyDayCapFactor);
  const newWeekdayValue = Math.ceil(
    (daycaps.weekly * dailyCapAdjustmentFactor) / NUMBER_OF_WEEKDAYS
  );
  DAYS.forEach(day => {
    daycaps[day.dayCapKey] = day.isWeekDay ? newWeekdayValue : 1;
  });
  return daycaps;
};

export const calcOverridesForSchedule = (daycaps, clientSchedule, overrideEnabled) => {
  if (!overrideEnabled) {
    return null;
  }
  const WEEKDAYS = DAYS.filter(d => d.isWeekDay);

  const scheduledWeekdays = WEEKDAYS.filter(d => clientSchedule[d.key].isActive);
  if (scheduledWeekdays.length === 0 || scheduledWeekdays.length === 5) {
    return null;
  }

  if (
    WEEKDAYS.filter(d => daycaps[d.dayCapKey] === -1 && clientSchedule[d.key].isActive).length > 0
  ) {
    return null;
  }

  const capToRedistribute = WEEKDAYS.filter(
    d => !clientSchedule[d.key].isActive && daycaps[d.dayCapKey] !== -1
  ).reduce((a, d) => {
    a += daycaps[d.dayCapKey];
    return a;
  }, 0);
  if (capToRedistribute === 0) {
    return null;
  }
  const redistList = redesctributeDays(capToRedistribute, scheduledWeekdays.length);
  return WEEKDAYS.reduce((a, d) => {
    a[d.dayCapKey] = clientSchedule[d.key].isActive ? daycaps[d.dayCapKey] + redistList.shift() : 0;
    return a;
  }, {});
};

// Note: these ratios need to match the ratios calculated in
// Tonquin.API\API\Tonquin.Business\ClientCapsPerScheduleOverride\ClientCapsPerScheduleOverrideEngine.cs
const ratios = [
  [],
  [1],
  [2.0 / 3.0, 1.0 / 3.0],
  [3.0 / 6.0, 2.0 / 6.0, 1.0 / 6.0],
  [4.0 / 10.0, 3.0 / 10.0, 2.0 / 10.0, 1.0 / 10.0],
];

const redesctributeDays = (capCountToRedestribute, totalActiveDays) => {
  if (totalActiveDays <= 0) {
    throw new Error('Total days must be greater then zero');
  }
  if (totalActiveDays >= 5) {
    throw new Error('Total days must be less than all week days');
  }
  if (capCountToRedestribute <= 0) {
    throw new Error('cap to redestribute must be greate than zero');
  }

  const redist = ratios[totalActiveDays].map(ratio =>
    roundTowardEven(ratio * capCountToRedestribute)
  );
  redist[0] =
    capCountToRedestribute -
    (redist.reduce((a, r) => {
      a += r;
      return a;
    }, 0) -
      redist[0]);

  return redist;
};

// C#'s default rounding algorithm is a gaussian/baker's rounding,
// which means it rounds towards the nearest multiple of 2. This reduces rounding
// bias when a large number of boundary (x.5) numbers are in a data set. Unfortunately,
// JavaScript doesn't have baker's rounding in the Math library, so we recreate it here.
const roundTowardEven = (num, decimalPlaces) => {
  const d = decimalPlaces ?? 0;
  const m = Math.pow(10, d);
  const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
  const i = Math.floor(n);
  const f = n - i;
  const e = 1e-8; // Allow for rounding errors in f
  const r = f > 0.5 - e && f < 0.5 + e ? (i % 2 === 0 ? i : i + 1) : Math.round(n);
  return d ? r / m : r;
};
